import React from 'react';
import { useAppDispatch } from '../store/hooks';
import { markCheckListItem } from '../store/onboardingSlice';
import './OnboardingViewHelpers.css';

const Checklist = ({ stage, onboarding, stateCheckList }) => {
  const dispatch = useAppDispatch();
  const onboardingType = onboarding?.onboardingType;
  
  // Check if onboardingType is null or empty
  const hasOnboardingType = onboardingType && onboardingType.trim() !== '';
  
  // Filter checklist items based on onboardingType
  const filteredCheckList = hasOnboardingType 
    ? Object.entries(stateCheckList).filter(([key, item]) => {
        return (item.workflows && item.workflows.includes(onboardingType)) || (item.workflows && item.workflows.includes("all"));
      })
    : Object.entries(stateCheckList);

  // Get the current checklist items for this stage
  const currentCheckList = onboarding?.stages?.[stage]?.checkList || [];

  // Handle checkbox change
  const handleCheckboxChange = async (checkListItem) => {
    try {
      await dispatch(markCheckListItem({
        onboardingId: onboarding.id,
        stage: stage,
        checkListItem: checkListItem
      })).unwrap();
    } catch (error) {
      console.error('Failed to mark checklist item:', error);
    }
  };

  return (
    <div className="mt-4">
      <h3 className="onboarding-helpers-checklist-title">Checklist</h3>
      <div className="space-y-2">
        {/* Show "Add onboardingType" item if onboardingType is missing */}
        {!hasOnboardingType && (
          <div className="onboarding-helpers-checklist-item onboarding-helpers-checklist-item-warning">
            <input
              type="checkbox"
              className="onboarding-helpers-checkbox"
              disabled
            />
            <span className="onboarding-helpers-text-warning">
              Add onboardingType to onboarding
            </span>
          </div>
        )}
        
        {/* Display filtered checklist items */}
        {filteredCheckList.map(([key, item]) => {
          const isChecked = currentCheckList.includes(key);
          return (
            <div key={key} className="onboarding-helpers-checklist-item onboarding-helpers-checklist-item-normal">
              <input
                type="checkbox"
                className="onboarding-helpers-checkbox"
                checked={isChecked}
                onChange={() => handleCheckboxChange(key)}
              />
              <span className="onboarding-helpers-text-normal">
                {item.description || item.descripttion || 'No description available'}
              </span>
            </div>
          );
        })}
        
        {/* Show message if no items match the onboardingType */}
        {hasOnboardingType && filteredCheckList.length === 0 && (
          <div className="onboarding-helpers-checklist-item onboarding-helpers-checklist-item-normal">
            <span className="onboarding-helpers-text-description">
              No checklist items found for onboarding type: {onboardingType}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

const ViewStageHistory = ({ onboarding, stage }) => {
  // Map stage names to their corresponding display functions
  // const stageDisplayFunctions = {
  //   signedDate: displayHistorySignedDate,
  //   kickoff: displayHistoryKickoff,
  //   isLinkedToPractice: displayHistoryLinkedToPractice,
  //   registrationComplete: displayHistoryRegistrationComplete,
  //   portRequest: displayHistoryPortRequest,
  //   phones: displayHistoryPhones,
  //   trainingKb: displayHistoryTrainingKb,
  //   trainingWorkflow: displayHistoryTrainingWorkflow,
  //   goLive: displayHistoryGoLive
  // };

  console.log("onboarding =", onboarding);

  const fullOnboardingHistory = onboarding ? Object.entries(onboarding?.stages).map(([stage, stageValue]) => {
    console.log("stageName =", stage);
    console.log("stageValue =", stageValue);


    return stageValue.history.map((historyItem) => {
      console.log("historyItem =", historyItem);
      return {
        time: historyItem.timestamp,
        oldStatus: historyItem.event.from,
        newStatus: historyItem.event.to,
        note: historyItem.note,
        stage: stage
      }
    })
  }).flat() : [];

  console.log("fullOnboardingHistory =", fullOnboardingHistory);

  const renderHistory = (onboardingHistory) => {
    console.log("Yeet");
    // For overview, show history for all stages
    return (
      <div className="mt-4">
        <h3 className="onboarding-helpers-history-title">Complete Stage History</h3>
        <div className="onboarding-helpers-history-container">
          <table className="onboarding-helpers-history-table">
            <thead>
              <tr className="onboarding-helpers-history-header">
                <th className="onboarding-helpers-history-header-cell">Stage</th>
                <th className="onboarding-helpers-history-header-cell">Time</th>
                <th className="onboarding-helpers-history-header-cell">Old Status</th>
                <th className="onboarding-helpers-history-header-cell">New Status</th>
                <th className="onboarding-helpers-history-header-cell">Note</th>
              </tr>
            </thead>
            <tbody>
              {onboardingHistory.map((historyItem) => {
                const hTime = new Date(historyItem.time);
                return (
                  <tr key={historyItem.time} >
                    <td>{historyItem.stage}</td>
                    <td>{hTime.toLocaleString()}</td>
                    <td>{historyItem.oldStatus}</td>
                    <td>{historyItem.newStatus}</td>
                    <td>{historyItem.note}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  let filteredOnboardingHistory = fullOnboardingHistory;
  if (stage !== 'overview') {
    filteredOnboardingHistory = fullOnboardingHistory.filter((historyItem) => historyItem.stage === stage);
  }

  return renderHistory(filteredOnboardingHistory);
};

export { ViewStageHistory, Checklist };
